import { BaseComponent } from '../../../base-component/base-component';
import { STATE_FACET } from '../interfaces/create-search-filter.interface';
import { SearchFacet } from '../../../search/interfaces/search.interface';
import { customElement, property } from 'lit/decorators.js';
import { html, nothing, TemplateResult } from 'lit';

@customElement('mhecomm-create-state-school-search-filter')
export class CreateStateSchoolSearchFilter extends BaseComponent {
  @property({ type: Array })
  facets?: SearchFacet[];

  @property({ type: Object })
  schoolFacet?: SearchFacet;

  renderComp(): TemplateResult | typeof nothing {
    if (this.schoolFacet === undefined) {
      return nothing;
    }

    const stateFacet = this.getStateFacet();

    return html`
      <div class="pb-2">
        <mhecomm-create-search-dropdown-filter
          .facet="${stateFacet}"
          ariaLabel="Select the state for filtering search results"
          ?disabled="${stateFacet?.facetValues.length === 0}"
          defaultOptionDisplayValue="Please select"
          defaultOptionFormValue="none"
          id="create-state"
          label="Select State, Territory or S.N.:"
          loadingDisplayValue="Loading states"
        >
        </mhecomm-create-search-dropdown-filter>
      </div>
      <div>
        <mhecomm-create-search-dropdown-filter
          .facet="${this.schoolFacet}"
          ariaLabel="Select the school for filtering search results"
          defaultOptionDisplayValue="Please select"
          defaultOptionFormValue="none"
          id="create-school"
          label="Select School:"
          loadingDisplayValue="Loading schools"
        >
        </mhecomm-create-search-dropdown-filter>
      </div>
    `;
  }

  private getStateFacet(): SearchFacet | undefined {
    return this.facets?.find((facet) => facet.name === STATE_FACET);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-create-state-school-search-filter': CreateStateSchoolSearchFilter;
  }
}
